/*
 * @Author: ç¯çç§æ(Lucas Huang)
 * @Date: 2019-07-10 11:44:49
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2019-09-25 18:10:54
 * @QQ: 1055818239
 * @Version: v0.0.1
 */
import { DataColumn } from '@farris/ui-common/column';

export type ONLY_SELECT_LEAF = 'default' | 'yes' | 'no';
export type LOAD_DATA_TYPE = 'all' | 'fav' | 'list' | 'nav' | 'search' | 'children'
                            | 'textchange' | 'sort' | 'navsearch' | 'selected' | 'allChildren' | 'navAllChildren';

export interface TreeInfo {
    /** æ°æ®å è½½æ¹å¼ï¼ all, async */
    loadDataType?: 'all' | 'async';
    /** åå±æ¹å¼ï¼ pathcode, parentId */
    layerType?: string;
    /** æ°æ®ä¸­å¸¦æåçº§ä¿¡æ¯çå­æ®µ */
    dataField?: string;
    /** ç¶IDå­æ®µ */
    parentField?: string;
    /** åçº§ç å­æ®µ */
    pathField?: string;
    /** çº§æ°å­æ®µ */
    layerField?: string;
    /** æ¯å¦æç»å­æ®µ */
    isDetailField?: string;
    /**
     * åªåè®¸éæ©å¶å­èç¹
     * - default: åºç¨æå¡å¨ç«¯è®¾ç½®ï¼å¦æå¡å¨æªè®¾ç½®ï¼åè½å  `no`
     * - `yes`: æå¡å¨ç«¯è®¾ç½®å¤±æãä»åè®¸éæ©å¶å­èç¹ã
     * - `no`:  æå¡å¨ç«¯è®¾ç½®å¤±æãææèç¹åå¯éæ©ã
     */
    onlySelectLeaf?: boolean | ONLY_SELECT_LEAF;
    /** æ ç»ææ°æ®æ¯å¦å·²åå§åå®æ */
    treeDataIsInit?: boolean;
}

export interface CustomStyleData {
    field: string, 
    value: string, comparator?: string, 
    styles: { [key: string]: any }
}

export interface LookupGridResult {
    /** åä¿¡æ¯ */
    columns?: DataColumn[];
    /** æ°æ®åè¡¨ */
    items?: any[];
    /** æ¥è¯¢å­æ®µ */
    searchFields?: { label: string, value: string }[];
    /** åé¡µä¿¡æ¯ */
    pageInfo?: { pageIndex: number, pageSize: number, pageList?: number[], enablePager: boolean };
    /** æ»è®°å½æ° */
    total?: number;
    /** åºå¼ */
    mapFields?: { desgine: string, runtime: string }[];
    /** æ åçº§ä¿¡æ¯ */
    treeInfo?: TreeInfo;
    displayType?: string;
    displayInfo?: DisplayInfo;
    title?: string;
    navigation?: NavigationOptions;
    valueField?: string;
    textField?: string;
    idField?: string;
    /** å·²éæ©æ°æ®åè¡¨ */
    selectedItems?: any;
    /** æ¶èæ°æ® */
    favoriteItems?: any[];
    /** èªå®ä¹è¡æ ·å¼ */
    customStyles?: {
        row?: Array<CustomStyleData>,
        cell?:Array<CustomStyleData>
    }
}

/** ä¸ªæ§åæ°æ® */
export interface PersonalConfig {
    tabIndex?: string;
    favorite?: {
        [lang: string]: any[];
    };
    quickSelected?: {
        [lang: string]: any[];
    };
    size?: any;
    selections?: any;
    cascadeStatus?: string;
    colSizeInfo?: {data: { [field: string]: number }, nav: {[field: string]: number}, fav: {[field: string]: number}};
    [key: string]: any;
}

export interface NavigationOptions extends LookupGridResult {
    [key: string]: any;
    displayType: 'List' | 'TreeList';
    width: number;
    idField?: string;
    relations?: { groupField: string, helpField: string }[];
    hover?: boolean;
}

export interface LookupGridOptions extends LookupGridResult {
    singleSelect?: boolean;
    idField?: string;
    uri?: string; // å¯ä»¥ä¸ºåæ°æ®IDãwebapi å°å
    showFilterBar?: boolean;
    pagination?: boolean;
    pageIndex?: number;
    pageSize?: number;
    pageList?: number[];
    total?: number;
    width?: number;
    height?: number;
    hover?: boolean;
}

export class DisplayInfo {
    title?: string;
    favorites?: string;
    okText?: string;
    cancelText?: string;
    allColumns?: string;
}

export const lookupGridDefaults: LookupGridOptions = {
    singleSelect: true,
    showFilterBar: true,
    pagination: true,
    pageIndex: 1,
    pageSize: 10,
    pageList: [10, 20, 30, 50, 100]
};

export const displayInfoDefault = {
    title: 'æ­¤å¤æ¾ç¤ºæ é¢',
    favorites: 'æ¶èå¤¹',
    okText: 'ç¡®å®',
    cancelText: 'åæ¶',
    allColumns: 'ææå'
};

/** å¸®å©åäºä»¶è¿åç±»å */
export interface PickingResult {
    /** true: ç»§ç»­æå¼å¸®å©ï¼false: ä¸æå¼å¸®å©çªå£ */
    showDialog: boolean;
    /** æºå¸¦çä¸äºèªå®ä¹æ°æ®ï¼ç±ä¸å¡å¨æå¡å¨ç«¯å¸®å©åäºä»¶ä¸­å¤ç */
    data?: any;
    message?: any;
}

export interface PickedResult {
    closeDialog: boolean;
    message?: any;
}
